import 'babel-polyfill';
import Vue from 'vue'
// import VueRouter from 'vue-router';
import {configure} from 'kpc/components/utils';
configure({useWrapper: true});
// Vue.use(VueRouter);
require('ksc-vue-ui2/src/styles/common.sass');
require('font-awesome/css/font-awesome.css');
require('./app/styles/common.sass');
window.$ = require('jquery');
window._ = require('lodash');

// const i18n = require('ksc-i18n');
import {$trans} from 'ksc-i18n';
// const commonCookie = require('./app/services/common/cookie');
import commonCookie from './app/services/common/cookie';

Vue.use({
    install(Vue) {
        Vue.$trans = Vue.prototype.$trans = $trans;
    }
});

// prod环境预处理
if (KSC_SECNET_CONSOLE.ENV === 'prod') {
    (function() {
        var noop = function noop() {};
        var methods = [
            'assert', 'clear', 'count', 'debug', 'dir', 'dirxml',
            'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
            'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
            'timeStamp', 'trace', 'warn'
        ];
        var length = methods.length;
        var console = window.console || {};

        while (length--) {
            console[methods[length]] = noop;
        }
    }());
    // 关闭vue的开发配置
    Vue.config.silent = true;
    Vue.config.devtools = false;
}
if (KSC_SECNET_CONSOLE.ENV === 'test') {
    // 关闭vue的开发配置
    // Vue.config.silent = true;
    Vue.config.devtools = false;
}
let lang = commonCookie.getCookie('ksc_lang') || 'zh';
// Vue.use(i18n.VueTransPlugin, window['kvm_lang_dict']);

import {localize} from 'kpc/components/utils';
import i18nKpc from 'kpc/i18n/en-US';
if (lang !== 'zh') {
    localize({
        ...i18nKpc,
        // ...window['kvm_lang_dict']
    });
} 
const store = require('./app/store/index').default
// const router = require('./app/router/purchaseView.js').default
// import routerLoading from 'ksc-vue-ui2/src/services/router-loading';
// routerLoading(router);
const purchaseView = resolve => {
    require.ensure(['./app/containers/purchaseView/index.vue'], require => {
        require(['./app/containers/purchaseView/index.vue'], resolve);
    }, 'purchase-view');
};
Vue.config.productionTip = false

export default new Vue({
    store,
    // router,
    // render: h => h('router-view'),
    render: h => h(purchaseView)
}).$mount('#app')
